import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { RELEASE_NOTES } from "../lib/releaseNotes";

const KEY = "mwcrm_release_balloon";
const GAP = 3 * 60 * 60 * 1000;
const MAX_PER_DAY = 5;

export default function ReleaseBalloon({ version }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!version || !RELEASE_NOTES.length) return;
    const onAction = () => {
      const today = new Date().toISOString().slice(0, 10);
      let s = {};
      try { s = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch (e) {}
      if (s.version !== version || s.day !== today) s = { version, day: today, count: 0, last: 0 };
      if (s.count >= MAX_PER_DAY || Date.now() - s.last < GAP) return;
      localStorage.setItem(KEY, JSON.stringify({ ...s, count: s.count + 1, last: Date.now() }));
      setShow(true);
    };
    window.addEventListener("click", onAction, true);
    window.addEventListener("keydown", onAction, true);
    return () => { window.removeEventListener("click", onAction, true); window.removeEventListener("keydown", onAction, true); };
  }, [version]);
  if (!show) return null;
  return (
    <div data-testid="release-balloon" className="fixed bottom-20 right-5 z-[70] w-80 rounded-2xl border border-emerald-500/40 bg-slate-900 p-4 text-slate-100 shadow-2xl">
      <button data-testid="release-balloon-close" onClick={() => setShow(false)} className="absolute right-2 top-2 rounded p-1 text-slate-400 hover:bg-slate-800 hover:text-white"><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-2 text-sm font-extrabold text-emerald-300"><Sparkles className="h-4 w-4" /> SÜRÜM {version} YAYINDA</div>
      <div className="mt-1 text-[11px] text-slate-400">BU İŞLEMLER EKLENDİ, KULLANABİLİRSİNİZ:</div>
      <ul className="mt-2 max-h-48 space-y-1 overflow-y-auto text-xs">
        {RELEASE_NOTES.slice(-6).reverse().map((n) => <li key={n} className="flex gap-1.5"><span className="text-emerald-400">•</span>{n}</li>)}
      </ul>
    </div>
  );
}
